var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer flex align-cen"},[_c('div',{},[_c('p',[_vm._v("北京和隆优化科技股份有限公司")]),_c('p',[_vm._v("© 2014-2020北京和隆优化科技股份有限公司 版权所有 京ICP备15057915")])]),_c('div',{staticClass:"mft"},[_vm._v(" 客服电话："),_c('span',[_vm._v("400-8811-519")])])])
}]

export { render, staticRenderFns }